export default __webpack_public_path__ + "static/intercom-text-df4ec0858c0b706290e3c823ef3019fc.svg";